// DS: C35
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MobileSubmissionDetails from './MobileSubmissionDetails';
import DesktopSubmissionDetails from './DesktopSubmissionDetails';
const SubmissionDetails = (props)=>{
    const isMobile = useContext(MobileContext);
    return isMobile ? /*#__PURE__*/ React.createElement(MobileSubmissionDetails, props) : /*#__PURE__*/ React.createElement(DesktopSubmissionDetails, props);
};
SubmissionDetails.displayName = 'SubmissionDetails';
export default SubmissionDetails;
